import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/sale';
import { listNavigator } from 'sagas/common';
import { filters }from 'filters/sale';

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Sale', actions, selectors, filters } );
}
